<template>
    <section>
        <div class="row">
            <p>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                Site para elaboração de denuncias e/ou complementação de denúncia já realizada, podendo anexar documentos, áudios, imagens ou vídeos.
            </p>

            <ul class="mt-4">
                <li>Para saber o andamento ou complementar sua denúncia, clique em <strong>CONSULTAR</strong> e siga as instruções.</li>
                <li>Para efetuar nova denúncia, clique em <strong>DENUNCIAR</strong> e siga as instruções.</li>
            </ul>
        </div>

        <div class="d-flex justify-content-center mt-5 mb-5">
            <router-link :to="{ name: 'new_denuncia' }">
                <div class="button mr-5">{{view_nome.denuncia_detalhe}}</div>
            </router-link>

            <router-link :to="{ name: 'den_consult' }">
                <div class="button mr-5">Consultar</div>
            </router-link>
        </div>
    </section>
</template>

<script>
export default {
    name: "Home",
    computed: {
            logotipo() { return this.$store.state.config.logotipo },
            view_nome(){ return this.$store.state.config_view_menu }
        }
}
</script>

<style>
    .button {
        background-color: rgb(39, 39, 39);
        border: solid 2px rgb(39, 39, 39);
        color: #FFF;
        padding: 30px 50px;
        transition: all 0.5s;
        margin: 0 3px
    }

    .button:hover {
        background-color: rgb(161, 161, 161);
        color: rgb(39, 39, 39);
    }
</style>